/**
 * Cross-device PDF/blob downloader.
 * Desktop: triggers an <a download> click.
 * Mobile (iOS Safari, in-app browsers): falls back to opening the blob in a new tab
 * because <a download> is often ignored on mobile and the file would silently fail.
 */
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const isMobile = /Android|iPhone|iPad|iPod|Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

  if (isMobile) {
    // Open in a new tab so the user can save/share manually
    const win = window.open(url, "_blank");
    if (!win) {
      // popup blocked → fallback to same-tab navigation
      window.location.href = url;
    }
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
    return;
  }

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1_000);
}
